import { search } from '@codemirror/search';
import { EditorState } from '@codemirror/state';

export const searchExtensions = () => {
  return [
    EditorState.readOnly.of(true),
    search({
      top: true,
    }),
  ];
};
